import Icon from '@tribus/icon';

/**
  * @summary Arrow icon component
  * @desc Element for declaring a arrow icon
  * @author Wade Penistone <wade@tribusdigital.com>
  * @namespace ArrowIcon
  * @constructor
  */
export default {
  name: 'arrow-icon',
  extends: Icon,
  props: {
    base: {default: 'arrow'}
  }
};
